import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";
import SearchTopBar from "~/features/SearchV3/components/SearchDialog/SearchTopBar";
import KeywordInputModal from "~/features/SearchV3/components/SearchForm/KeywordInputModal";
import useKeywordSearch from "~/features/SearchV3/hooks/useKeywordSearch";

interface FilterKeywordModalProps {
    setTextValue: React.Dispatch<React.SetStateAction<string>>;
}

const FilterKeywordModal = ({ setTextValue }: FilterKeywordModalProps) => {
    const { closeModal } = useKeywordSearch();
    const clickRef = useRef(null);

    useOnClickOutside(clickRef, () => closeModal(true));

    return (
        <div ref={clickRef} className="bg-white rounded shadow-lg w-full max-w-3xl mx-auto">
            <div className="flex items-center gap-1 py-3 px-4 w-full min-w-[47.5rem] h-16">
                <SearchTopBar />
            </div>
            <div className="w-full pt-0 pb-4 px-4">
                <KeywordInputModal setTextValue={setTextValue} />
            </div>
        </div>
    );
};

export default FilterKeywordModal;
